(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["main-menu-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nordeen-navigation')) {
    customElements.define('nordeen-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = [...this.querySelectorAll('[data-nd-tab]')];
        this.panels = [...this.querySelectorAll('[data-nd-panel]')];
        this.addEventListener('click', event => {
          const tab = event.target.closest('[data-nd-tab]');
          const opener = event.target.closest('[data-nd-open]');
          if (tab) this.selectTab(tab.dataset.ndTab);
          if (event.target.closest('[data-nd-all-brands]')) this.selectTab('merken', true);
          if (opener) {
            const panel = opener.closest('[data-nd-panel]');
            const detail = panel.querySelector('#' + opener.dataset.ndOpen);
            if (!detail) return;
            this.returnTo = opener;
            panel.querySelectorAll('[data-nd-view]').forEach(view => view.hidden = view !== detail);
            opener.setAttribute('aria-expanded', 'true');
            detail.querySelector('h2').focus({preventScroll:true});
            this.scrollTop();
          }
          if (event.target.closest('[data-nd-back]')) {
            const panel = event.target.closest('[data-nd-panel]');
            this.resetPanel(panel);
            this.returnTo?.focus({preventScroll:true});
            this.scrollTop();
          }
        });
        this.querySelector('[role="tablist"]').addEventListener('keydown', event => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          let target;
          if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') target = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.tabs.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.selectTab(this.tabs[target].dataset.ndTab, true);
        });
        this.closest('header-menu-drawer').addEventListener('dialog:after-hide', () => {
          this.panels.forEach(panel => this.resetPanel(panel));
        });
      }
      resetPanel(panel) {
        panel.querySelectorAll('[data-nd-view]').forEach(view => view.hidden = view.dataset.ndView !== 'root');
        panel.querySelectorAll('[data-nd-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      }
      selectTab(key, focus = false) {
        this.tabs.forEach(tab => {
          const active = tab.dataset.ndTab === key;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus({preventScroll:true});
        });
        this.panels.forEach(panel => {
          panel.hidden = panel.dataset.ndPanel !== key;
          this.resetPanel(panel);
        });
        this.querySelector('.nd-popular').hidden = key === 'merken';
        this.scrollTop();
      }
      scrollTop() { this.closest('.nd-scroll').scrollTop = 0; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
